import TemplateMixin from './TemplateMixin';
import { Component, Mixins, Watch } from 'vue-property-decorator';

@Component({})
export default class VideoTemplate extends Mixins(TemplateMixin) {
  $refs!: {
    element: HTMLElement;
  };

  get src(): string {
    return this.component.value;
  }

  get loop(): boolean {
    return this.component?.metadata?.loop;
  }

  get muted(): boolean {
    return this.component?.metadata?.muted;
  }

  get volume(): number {
    return this.component?.metadata?.volume;
  }

  get refName(): string {
    return `videoTemplate-${this.component.id}`;
  }

  get width(): number {
    return this.component.w;
  }

  mounted() {
    this.adjustVolume();
  }

  @Watch('volume')
  @Watch('muted')
  adjustVolume() {
    // muted takes higher priority than volume
    if (this.muted) {
      this.$refs[this.refName].muted = true;
      return;
    }

    this.$refs[this.refName].muted = false;
    this.$refs[this.refName].volume = this.volume;
  }

  @Watch('loop')
  startLooping() {
    // start video when loop is set to true and video is paused
    if (!this.loop) return;

    if (this.$refs[this.refName].paused) this.$refs[this.refName].play();
  }
}
